module.exports = function isNumber(x) {
  return typeof x === 'number' && isFinite(x) && !isNaN(x);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/~/tcomb/lib/isNumber.js
 ** module id = 498
 ** module chunks = 0
 **/